<template>
  <div
    class="invoices"
  >
    <loading-screen v-if="isLoading" />
    <div v-if="invoices.serviceId">
      <div>
        <h2
          class="bold"
          name="bill payment"
        >
          Pago de Factura
        </h2>
        <h4
          name="phone cons"
        >
          {{ (token.numberType === '3' || token.numberType === '0')
            ? 'ID': 'Teléfono' }}: {{ msisdn | formatPhone }}
        </h4>
      </div>

      <template
        v-if="
          invoices.pendingInvoices &&
            invoices.pendingInvoices.length > 0
        "
      >
        <h6
          name="description"
          class="text-gray"
        >
          Tus cuentas Claro agrupadas por servicio.
        </h6>
        <ul class="invoices__list">
          <li
            v-for="(invoice, index) in invoices.pendingInvoices"
            :key="index"
          >
            <label
              class="invoice"
              :class="{'invoice--active' : invoicesSelected.some(
                ({id}) => id === invoice.id)}"
            >
              <div class="grid flex-grow">
                <span class="bold w-full mb-0">
                  Saldo de factura {{ isDued(invoice) ? "vencida" : "por vencer" }}
                </span>
                <div class="flex">
                  <span
                    class="bold"
                    name="amount"
                    :class="{ 'text-red': isDued(invoice) }"
                  >
                    {{ country.money }}{{ invoice.dueAmount | toFixed }}
                  </span>

                  <span
                    class="ml-4 text-center"
                    name="dueDate"
                  >{{ invoice.dueDate | local }}
                  </span>
                </div>
              </div>
              <input
                v-if="!invoice.isProcessing"
                :id="invoice.id"
                v-model="invoicesSelected"
                name="some-radios"
                :value="{
                  serviceId: invoices.serviceId,
                  ...invoice
                }"
                class="checkbox"
                type="checkbox"
              />

              <p
                v-if="invoice.isProcessing"
                class="bold pb-0 mb-0 text-red"
              >
                Pago en proceso
              </p>
            </label>
          </li>
        </ul>
        <div class="amount">
          <p>
            Total
          </p>
          <hr />
          <p id="totalAmount">
            {{ country.money }}{{ totalRecords | toFixed }}
          </p>
        </div>
      </template>

      <template v-else>
        <div class="no-bills">
          <p
            name="no bills"
          >
            {{ $t('text.noInvoicesNow') }}
          </p>
          <p name="likeF">
            ¿Te gustaría ahorrarte tiempo el próximo mes?
          </p>
          <p
            class="text-xl"
            name="ActiveF"
          >
            ¡Activa tu Débito Automático Mensual hoy!
          </p>
        </div>
      </template>

      <div>
        <div class="buttons">
          <template
            v-if="invoices.pendingInvoices &&
              invoices.pendingInvoices.length > 0"
          >
            <button
              id="topay"
              class="button"
              :class="{'text-xl': isPA || bitcoinEnabled}"
              :disabled="invoicesSelected.length <= 0"
              @click="processInvoice"
            >
              {{ isPA || bitcoinEnabled
                ? 'Pagar con Visa, Mastercard o AMEX' : 'Pagar Factura' }}
            </button>
            <button
              v-if="isPA || bitcoinEnabled"
              class="button text-xl"
              :disabled="invoicesSelected.length <= 0"
              @click="payWithProvider"
            >
              Pagar con {{ isPA ? 'Clave' : 'Bitcoin' }}
            </button>
          </template>
          <template v-else>
            <button
              class="button"
              name="pp_continue"
              @click="activateRecurrentPayment"
            >
              Continuar
            </button>
            <button
              class="button"
              name="pp_out"
              @click="$router.push({ name: 'SetNumber' })"
            >
              Salir
            </button>
          </template>
        </div>
      </div>

      <popup
        v-if="payDuedInvoices"
        @back="payDuedInvoices = false"
      />
    </div>

    <div
      v-if="!invoices.serviceId && isError"
      class="mb-2"
    >
      <h3 class="text-center text-red">
        {{ isError }}
      </h3>
    </div>
    <ClaveModal
      v-model="showModalClave"
      :payment-object="paymentObject"
    />
  </div>
</template>

<script>
import jwt from 'jwt-decode';
import LogRocket from 'logrocket';
import storage from '@lagersoft/key-storage';
import { mapActions, mapGetters } from 'vuex';
import { SV, PA, MPC } from '@/utils/constants';
import { mixinPushInvoicesErrorRoute } from '@/mixins/errorMixins';
import Popup from '../common/Components/PayFirstDueInvoices';
import ClaveModal from './InvoicesComponents/ClaveModal';

export default {
  name: 'Payment',
  components: {
    Popup,
    ClaveModal
  },
  mixins: [mixinPushInvoicesErrorRoute],
  data() {
    return {
      payDuedInvoices: false,
      isLoading: false,
      error: false,
      showModalClave: false,
      selected: null,
      isError: '',
      invoicesSelected: [],
      totalRecords: 0,
      paymentObject: {}
    };
  },
  computed: {
    ...mapGetters(['app', 'invoices', 'pack', 'country', 'isChatbot']),
    msisdn() {
      return jwt(storage.get('tokenIvr')).msisdn;
    },
    token() {
      return jwt(storage.get('tokenIvr'));
    },
    isSV() {
      return this.country.pais === SV;
    },
    isPA() {
      return this.country.pais === PA;
    },
    bitcoinEnabled() {
      return this.app === MPC && this.isSV;
    }
  },
  watch: {
    invoicesSelected: {
      deep: true,
      handler(val) {
        this.calculateTotal(val);
      }
    }
  },
  created() {
    this.getInvoices();
  },
  methods: {
    ...mapActions(['setInvoices']),
    getInvoices() {
      this.isLoading = true;
      global.api
        .mpcGetInvoices()
        .then((res) => {
          this.isLoading = false;
          this.setInvoices(res.data);
          this.$fullStory.event('getInvoices', { isSuccessful_bool: true });
          LogRocket.identify(res.data.serviceId);
        })
        .catch((err) => {
          this.isLoading = false;
          this.pushInvoicesErrorRoute(err); //  mixin
        });
    },
    payWithProvider() {
      this.paymentObject = {
        serviceId: this.invoices.serviceId,
        referencesToPay: []
      };
      this.invoicesSelected.forEach(
        (invoice) => this.paymentObject.referencesToPay.push(...invoice.reference)
      );
      let invoiceCount = 0;
      this.invoices.pendingInvoices.forEach((elem) => {
        if (!elem.isProcessing) {
          invoiceCount++;
        }
      });
      if (this.invoicesSelected.length !== invoiceCount) {
        if (this.stillOwesAnOlderInvoice()) {
          this.payDuedInvoices = true;
          return;
        }
      }

      if (this.isPA) this.showModalClave = true;
      else if (this.bitcoinEnabled) this.payWithBitcoin();
    },
    payWithBitcoin() {
      this.isLoading = true;
      global.api.mpcPostPaymentBitcoin(this.paymentObject).then((res) => {
        this.isLoading = false;
        window.location.href = res.data;
      }).catch(() => {
        this.isLoading = false;
        this.$router.push({ name: 'Error', query: { error: 'GENERIC_ERROR' } });
      });
    },
    back() {
      this.error = false;
    },
    calculateTotal(val) {
      let total = 0;
      if (val.length > 0) {
        val.forEach((invoice) => {
          total += invoice.dueAmount;
        });
      }
      this.totalRecords = total;
    },
    processInvoice() {
      this.isLoading = true;

      const selectedProcessing = this.invoicesSelected.some(({ isProcessing }) => isProcessing);

      if (selectedProcessing || this.stillOwesAnOlderInvoice()) {
        this.payDuedInvoices = true;
        this.isLoading = false;
        return;
      }

      const paymentObject = {
        serviceId: this.invoices?.serviceId,
        referencesToPay: this.invoicesSelected
          .reduce((arr, { reference }) => [...arr, ...reference], [])
      };

      global.api.mpcPostPayment(paymentObject)
        .then((res) => {
          this.isLoading = false;
          window.location.href = res.data;
        })
        .catch(() => {
          this.isLoading = false;

          this.$router.push({
            name: 'Error',
            query: { error: 'GENERIC_ERROR' }
          });
        });
    },
    stillOwesAnOlderInvoice() {
      const { pendingInvoices } = this.invoices;
      const selectedInvoices = this.invoicesSelected;

      const duedInvoices = (invoices) => invoices.filter(this.isDued);

      const notSelectedInvoices = pendingInvoices.filter(
        (invoice) => !selectedInvoices?.some((elem) => elem.id === invoice.id)
      );

      const duedInvoicesNotSelected = duedInvoices(notSelectedInvoices);

      if (duedInvoicesNotSelected.length === 0) {
        return false;
      }

      const oldestInvoice = (invoices) => invoices?.reduce(
        (prev, current) => (new Date(prev?.dueDate) < new Date(current?.dueDate) ? prev : current)
      );

      const newerInvoice = (invoices) => invoices?.reduce(
        (prev, current) => (new Date(prev?.dueDate) > new Date(current?.dueDate) ? prev : current)
      );

      const oldestDuedInvoiceNotSelected = oldestInvoice(duedInvoicesNotSelected);
      const newestInvoiceSelected = newerInvoice(selectedInvoices);

      const { dueDate: oldestDuedDate } = oldestDuedInvoiceNotSelected;
      const { dueDate: newestInvoiceSelectedDueDate } = newestInvoiceSelected;

      return new Date(oldestDuedDate) < new Date(newestInvoiceSelectedDueDate);
    },
    isDued(invoice) {
      const dueDate = new Date(invoice.dueDate);
      return dueDate < new Date();
    },
    isNewer(newer, older) {
      return new Date(newer.dueDate) > new Date(older.dueDate);
    },
    activateRecurrentPayment() {
      this.isLoading = true;
      global.api.getCreateRecurringPayment()
        .then((res) => {
          this.isLoading = false;
          window.location.href = res.data;
        })
        .catch((err) => { this.pushInvoicesErrorRoute(err); });
    }
  }
};
</script>

<style scoped lang="scss">
.invoices {
  margin-top: 3rem;
  text-align: center;
  width: 100%;
  p {
    margin: 0;
  }

  hr {
    margin-bottom: 0;
    margin-top: 0;
  }

  @media screen and (max-width: 370px) {
    .button {
      font-size: 20px;
    }
  }

  .no-bills {
    text-align: center;
    font-weight: bold;
    display: grid;
    gap: 1rem;
    margin: 1.5rem 0;
  }

  .buttons {
    display: grid;
    gap: 1.5rem;
  }

  .invoices__list {
    text-align: left;
    margin: 2rem 0;
    list-style: none;
    padding: 0;
  }

  .invoice {
    border: 1px solid #ccc;
    border-radius: 1.125rem;
    background-color: get-color('clear');
    padding: 1rem;
    margin: .5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    p, label {
      margin-bottom: 0;
    }
    &--active {
      // box-shadow: inset 0 0 0 1px get-color('pure-black');
      box-shadow: inset 0 0 0 2px $active;
    }
  }

  .amount {
    text-align: left;
    padding-inline: 1rem;
    margin: 1rem 0;
    font-weight: bold;
  }
}

@media screen and (max-width: 300px) {
  .invoices {
    margin: 1rem 0;
    font-size: .875rem;
    h2 {
      font-size: 1.75rem;
    }
    h4 {
      font-size: 1rem;
    }

    .invoices__list {
      margin: 1rem 0;
    }

    .invoice {
      padding: 0.5rem;
    }

    .buttons {
      gap: .5rem;
    }

    .button {
      font-size: 1rem;
      height: auto;
    }
  }
}
</style>
